import React from 'react';
import { Link } from 'react-router-dom';
import { Flex, Button, IconButton, useColorMode, Menu, MenuButton, MenuList, MenuItem, useMediaQuery } from "@chakra-ui/react";
import { SunIcon, MoonIcon } from "@chakra-ui/icons";
import { FaHome, FaBriefcase, FaUser, FaAddressBook } from "react-icons/fa";

const Navbar = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const [isSmallerScreen] = useMediaQuery("(max-width: 700px)");

  return (
    <Flex
      as="nav"
      align="center"
      justify={{ base: "center", md: "flex-end" }}
      padding={{ base: 4, md: 4 }}
      bg={colorMode === "light" ? "white" : "gray.800"}
      position="sticky" // Keep the Navbar fixed
      top={0}
      width="100%"
      zIndex={1000}
      gridGap={"8px"}
      fontFamily={"Roboto sans-serif"}
    >
      {isSmallerScreen ? (


  <Flex style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
      {/* Left side: Home Button */}
      <Button
        as={Link}
        to="/"
        colorScheme="purple"
        variant="ghost"
        leftIcon={<FaHome />}
        _hover={{ backgroundColor: 'purple.900', color: 'white' }}
      >
        Home
      </Button>

      {/* Right side: Menu items and theme toggle */}
      <Flex  style={{ display: 'flex', alignItems: 'center' }}>
        <Menu >
          <MenuButton
            as={IconButton}
            aria-label="Toggle dropdown"
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            }
          />
          <MenuList>
          <MenuItem>
             <Button
                as={Link}
                to="/experience"
                colorScheme="purple"
                variant="ghost"
                leftIcon={<FaHome />}
                _hover={{ backgroundColor: "purple.900", color: "white"}}
              >
                Experience
              </Button>
            </MenuItem>
            <MenuItem>
              <Button
                as={Link}
                to="/projects"
                colorScheme="purple"
                variant="ghost"
                leftIcon={<FaBriefcase />}
                _hover={{ backgroundColor: 'purple.900', color: 'white' }}
              >
                Projects
              </Button>
            </MenuItem>
            <MenuItem>
              <Button
                as={Link}
                to="/about"
                colorScheme="purple"
                variant="ghost"
                leftIcon={<FaUser />}
                _hover={{ backgroundColor: "purple.900", color: "white" }}
              >
                About
              </Button>
            </MenuItem>
            <MenuItem>
              <Button
                as={Link}
                to="/contact"
                colorScheme="purple"
                variant="ghost"
                leftIcon={<FaAddressBook />}
                _hover={{ backgroundColor: "purple.900", color: "white" }}
              >
                Contact
              </Button>
            </MenuItem>
          </MenuList>
        </Menu>
        <IconButton
          aria-label="Toggle color mode"
          icon={colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
          onClick={toggleColorMode}
        />
      </Flex>
    </Flex>
      ) : (
        <>
          <Button
            as={Link}
            to="/"
            colorScheme="purple"
            variant="ghost"
            leftIcon={<FaHome />}
            _hover={{ backgroundColor: "purple.900", color: "white" , transform: "scale(1.1)" }}
          >
            Home
          </Button>
          
          <Button
            as={Link}
            to="/experience"
            colorScheme="purple"
            variant="ghost"
            leftIcon={<FaBriefcase />}
            _hover={{ backgroundColor: "purple.900", color: "white" , transform: "scale(1.1)" }}
          >
            Experience
          </Button>
          <Button
            as={Link}
            to="/projects"
            colorScheme="purple"
            variant="ghost"
            leftIcon={<FaBriefcase />}
            _hover={{ backgroundColor: "purple.900", color: "white" , transform: "scale(1.1)" }}
          >
            Projects
          </Button>
          <Button
            as={Link}
            to="/about"
            colorScheme="purple"
            variant="ghost"
            leftIcon={<FaUser />}
            _hover={{ backgroundColor: "purple.900", color: "white", transform: "scale(1.1)"  }}
          >
            About Me
          </Button>
          <Button
            as={Link}
            to="/contact"
            colorScheme="purple"
            variant="ghost"
            leftIcon={<FaAddressBook />}
            _hover={{ backgroundColor: "purple.900", color: "white" , transform: "scale(1.1)" }}
          >
            Contact
          </Button>
          <IconButton
            aria-label="Toggle color mode"
            icon={colorMode === "light" ? <MoonIcon /> : <SunIcon />}
            onClick={toggleColorMode}
          />
        </>
      )}

    </Flex>
  );
};

export default Navbar;
